import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static getDebriefs() {
    return this.apiRequest(
      API_SUFFIX + "/api/editor/DebriefsForCurrentUser",
      {},
      "GET"
    );
  }
}
